function findInteractiveElements(container) {
  // The list of interactive elements is bassed on this: https://html.spec.whatwg.org/multipage/dom.html#interactive-content
  return container.querySelectorAll(
    `a[href], audio[controls], button, details, embed, iframe, img[usemap], input:not([type="hidden"]), label, select, textarea, video[controls]`
  );
}

export default findInteractiveElements;